import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export interface ButtonLayout {
    readonly selected: boolean;
}

export const LayoutButton = styled(Button)<ButtonLayout>`
    color: ${(props) => (props.selected ? 'var(--minor-accent__enabled__front__default);' : 'inherit')};
    min-width: 48px;
`;

export const LayoutsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: auto;
`;

export const ItemsHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    flex-direction: row;
    width: auto;
    grid-template-columns: 1fr auto 1fr;
    margin-top: 0.5rem;
    margin-bottom: 2rem;

    > * {
        align-self: center;
    }

    > :nth-of-type(3) {
        margin-left: auto;
    }
`;
